import api from './api';

export const memberAuth = {
  sendOtp: async (phoneData) => {
    const response = await api.post('/member/send-otp', phoneData);
    return response.data;
  },
  sendCallOtp: async (phoneData) => {
    const response = await api.post('/member/send-call-otp', phoneData);
    return response.data;
  },
  verifyOtp: async (otpData) => {
    const response = await api.post('/member/verify-otp', otpData);
    const { member, token } = response.data;

    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(member));
    localStorage.setItem('userType', 'member');

    return { member, token };
  },

  logout: async () => {
    try {
      await api.post('/member/logout');
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('userType');
    }
  },

  me: async () => {
    const response = await api.get('/member/me');
    return response.data;
  },

  isAuthenticated: () => {
    const token = localStorage.getItem('token');
    const userType = localStorage.getItem('userType');
    return !!token && userType === 'member';
  },

  getUser: () => {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  }

  // Add this method

};